












































import { defineComponent, onMounted, PropType, ref, useRouter } from '@nuxtjs/composition-api';
import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage.vue';
import VehiclesList from '@shared/components/Vehicles/VehiclesList.vue';
import useFitment from '@shared/composables/useFitment';
import useMyGarage from '@shared/composables/useMyGarage';
import { GarageVehicle } from '@shared/composables/useMyGarage/types';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { UCButtonGroup } from '@shared/ui';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';

import AMXButton from '~/components/AMXButton.vue';
import ListEmptyMessage from '~/components/VehiclesSideBar/ListEmptyMessage.vue';
import SidebarHeading from '~/components/VehiclesSideBar/SidebarHeading.vue';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';

export default defineComponent({
  name: 'SearchResults',
  components: {
    ListEmptyMessage,
    AMXButton,
    ErrorMessage,
    SidebarHeading,
    UCButtonGroup,
    VehiclesList,
    SidebarSubheading,
  },
  props: {
    result: {
      type: Array as PropType<PartsDbVehicleSummary[]>,
      default: null,
    },
    error: {
      type: Object as PropType<Error>,
      default: null,
    },
    searchAgainCallback: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props) {
    const selectedVehicle = ref<GarageVehicle | undefined>();
    const { addVehicle } = useMyGarage();
    const { close, setView } = useVehiclesSidebar();
    const { navigateToParts } = useFitment();
    const router = useRouter();

    const onVehicleSelectionChanged = (vehicle: GarageVehicle) => {
      selectedVehicle.value = vehicle;
    };

    const onShopPartsClicked = () => {
      if (!selectedVehicle.value) return;
      addVehicle(selectedVehicle.value);
      close();
      navigateToParts();
    };

    const onSearchAgainClicked = () => {
      props.searchAgainCallback();
    };

    const onContactClicked = () => {
      close();
      router.push('/pages/contact');
    };

    const onManualClicked = () => {
      setView(VehicleSidebarState.MANUAL_SEARCH);
    };

    onMounted(() => {
      if (props.result?.length === 1) {
        selectedVehicle.value = props.result[0];
      }
    });

    return {
      selectedVehicle,
      onVehicleSelectionChanged,
      onShopPartsClicked,
      onSearchAgainClicked,
      onContactClicked,
      onManualClicked,
    };
  },
});
